import React, { useEffect, useState } from "react";
import TitleUnderlined from "../../components/TitleUnderlined";
import Button from "../../components/Button";
import { RoutesWeb } from "../../tools/RoutesWeb";
import Breadcrumb from "../../components/Breadcrumb";
import { useNavigate } from "react-router-dom";
import APIInterface from "../../tools/APIInterface";
import { ShimmerTable } from "../../components/Shimmer";
import User from "../../models/User";
require('../../style/views/ticketDetails.scss');

const LeadersView = () => { 
    const token = localStorage.getItem('tokenGroup');
    const navigate = useNavigate();
    const [users, setUsers] = useState(null);

    useEffect(() => {
        if(!token) {
            navigate(RoutesWeb.ADMIN_LOGIN);
        }
    });

    if(users === null) {
        APIInterface.users(token)
        .then((response) => {
            if(response.status === 200){
                let _users = [];
                response.data.map((json) => {
                    let user = User.fromJSON(json);
                    _users.push(user);
                    return user;
                });
                setUsers(_users);
            }
        })
        .catch((error) => {
            console.error(error);
        });
    }

    return (
        <div className="pt-5 pb-5" id="ticketDetail">
            <br></br>
            <br></br>
            <Breadcrumb items={[
                {
                    title: 'Dashboard',
                    route: RoutesWeb.ADMIN_DASHBOARD
                },
                {
                    title: 'Lista de Líderes',
                    active: true
                },
            ]} />
            <div>
                <TitleUnderlined>Lista de <span className="embercom_overlined">Líderes</span></TitleUnderlined>
                <br />
                <br />
                <table className="table border-0">
                    <thead>
                        <tr>
                            <th className="semibold border-0">Id</th>
                            <th className="semibold border-0">Nombre</th>
                            <th className="semibold border-0">Boletos Registrados</th>
                            {/* <th className="semibold border-0">Fecha</th>
                            <th className="semibold border-0">Lugar</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {users !== null ?
                        users.map((user, index) => {
                            return <tr key={index} className="border-0">
                                <td className="border-0"><b>{index+1}</b></td>
                                <td className="border-0"><input className="form-control" value={user.name} type="text" disabled /></td>
                                <td className="border-0"><input className="form-control" value={user.attendees.length} type="email" disabled /></td>
                                {/* <td className="border-0"><input className="form-control" type="text" disabled /></td>
                                <td className="border-0"><input className="form-control" type="text" disabled /></td> */}
                            </tr>
                        })
                        :
                        <tr>
                            <td colSpan={5}>
                                <ShimmerTable />
                            </td>
                        </tr>
                    }
                    </tbody>
                </table>
                <br ></br>
                <br ></br>
                <a href={`${process.env.REACT_APP_API_URL}/api/download/attendees`} target="_blank" rel="noreferrer" style={{textDecoration: "none",color: "black"}}>
                    <Button>Descargar lista de <br/> boletos reservados <img src={require('../../assets/arrow_next.png')} alt="arrowNext" /></Button>
                </a>
            </div>
        </div>
    )
}

export default LeadersView;